// extracted by mini-css-extract-plugin
export var block = "promoted-items-module--block--35Pkj";
export var container = "promoted-items-module--container---PQp7";
export var list = "promoted-items-module--list--Mjxw6";